import React from 'react'
import type { Province } from '../data/provinces'
import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from './Tooltip'

interface MapPathProps {
  province: Province
  isHovered: boolean
  selectedColor: string
  defaultColor: string
  strokeColor: string
  onMouseEnter: (provinceName: string) => void
  onMouseLeave: () => void
  provinceNameColor: string
}

const MapPath: React.FC<MapPathProps> = ({ province, isHovered, selectedColor, defaultColor, strokeColor, onMouseEnter, onMouseLeave, provinceNameColor }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <path
          id={province.id}
          d={province.path}
          className="transition-colors duration-300 ease-in-out cursor-pointer hover:brightness-95 hover:text-white"
          style={{
            fill: isHovered ? selectedColor : defaultColor,
            stroke: strokeColor,
            strokeWidth: 1,
          }}
          onMouseEnter={() => onMouseEnter(province.name)}
          onMouseLeave={onMouseLeave}
          role="button"
          aria-pressed={isHovered}
          aria-label={`${province.name}`}
        />
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent side="top" align="center">
          <p className="text-center" style={{ color: provinceNameColor }}>{province.name}</p>
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  )
}

export default MapPath
